import { ThemeType } from '.'

export const DefaultTheme: ThemeType = {
  color: {
    accentBlue: 'var(--accent-blue)',
    yellow: 'var(--yellow)',
    red: 'var(--red)',
    green: 'var(--green)',
    purple: 'var(--purple)',
    pastelAccentBlue: 'var(--pastel-accent-blue)',
    pastelYellow: 'var(--pastel-yellow)',
    pastelRed: 'var(--pastel-red)',
    pastelGreen: 'var(--pastel-green)',
    transparentAccentBlue: 'var(--transparent-accent-blue)',
    transparentYellow: 'var(--transparent-yellow)',
    transparentRed: 'var(--transparent-red)',
    transparentGreen: 'var(--transparent-green)',
    textBlack: 'var(--text-black)',
    borderGray: 'var(--border-gray)',
    borderLightGray: 'var(--border-light-gray)',
    iconGray: 'var(--icon-gray)',
    white: 'var(--white)',
    textGray: 'var(--text-gray)',
    lightGray: 'var(--light-gray)',
    focus: 'var(--focus)',
    shadowSm: 'var(--shadow-sm)',
    loadingEvent: {
      sell: '#1D59E0',
      buy: '#1BAC83',
      other: '#333333',
      light: {
        sell: '#c6d5f7',
        buy: '#c6eae0',
        other: '#bbbbbb'
      },
      undetermined: 'var(--red)'
    },
    transferEvent: '#888888',
    restEvent: {
      truck: 'var(--accent-blue)',
      driverEmployee: 'var(--green)',
      reason: {
        holiday: 'var(--accent-blue)',
        pitIn: 'var(--yellow)',
        siteWork: 'var(--red)',
        other: 'var(--green)'
      }
    }
  }
}
